import React from "react";

import { IconButtonTypes } from "../../types/button";

import Icon from "../icon/Icon";

const IconButton = ({
  name,
  handleClick,
  size,
  socialButton,
  color,
  type,
  teamModal,
  aria
}: IconButtonTypes) => {
  return (
    <button
      className={`a-iconButton ${
        socialButton ? "-socialButton justify-center" : ""
      } ${teamModal ? "-teamModal" : ""}`}
      onClick={handleClick}
      type={type}
      aria-label={`${aria?.label || ""}`}
    >
      <Icon name={name} size={size} color={color} />
    </button>
  );
};

export default IconButton;
